module.exports = __webpack_public_path__ + "static/media/nft-SoftShapes.7743ef65.png";